import { render, staticRenderFns } from "./TheCaption.vue?vue&type=template&id=095ab8de&"
import script from "./TheCaption.vue?vue&type=script&lang=js&"
export * from "./TheCaption.vue?vue&type=script&lang=js&"
import style0 from "./TheCaption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports